import AdminSiteDetail from './AdminSiteDetail'
export default AdminSiteDetail
